import axios from "axios";
import api from "../../../../../Shared/Config/AxiosInstance";
import { ApiResponse } from "../../../../../Shared/Model/ApiResponse";
import { PaginationResult } from "../../../../../Shared/Model/PaginationResult";
import OffersPromoDataSource from "../OffersPromoDataSource";
import { BannerAPIEntity } from "./Entity/BannerAPIEntity";
import { BannersAPIEntity } from "./Entity/BannersAPIEntity";
import { BannerStateAPIEntity } from "./Entity/BannerStateAPIEntity";
import { OfferAPIEntity, OfferAPIEntityUpdateImageAndTiner, OfferAPIEntityUpdateSlider, OfferItemsImageAndTimer, OfferItemsSlider, OfferRows, UpdateOffer } from "./Entity/OfferAPIEntity";
import { OfferItemSliderAPIEntity } from "./Entity/OfferItemSliderAPIEntity";
import { OffersAPIEntity } from "./Entity/OffersAPIEntity";
import { OfferStateAPIEntity } from "./Entity/OfferStateAPIEntity";
import { ProductAPIEntity } from "./Entity/ProductAPIEntity";
import { ProductsAPIEntity } from "./Entity/ProductsAPIEntity";

const baseURLBanner = `v1/banner`;

const baseURLProduct = `v1/Product/for-banner`;

const baseURLOffer = `v1/Offer`;

export default class OffersPromoAPIDataSourceImpl implements OffersPromoDataSource{


  async updateBannerList(bannerId: number, data: FormData): Promise<boolean> {
    try {
      // Realiza la petición PUT utilizando api
      const response = await api.put<ApiResponse<any>>(`${baseURLBanner}/${bannerId}/banner-details`, data, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
      });

      // Verifica si la respuesta contiene datos
      if (response.data?.succeeded) {
        // Devuelve true si la actualización fue exitosa
        return true;
      } else {
        console.warn("La API respondió con un formato inesperado:", response.data, {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        });
        return false;
      }
    } catch (error: any) {
        // Si hay error en la respuesta, intentamos obtener detalles
        if (error.response) {
          console.error(`Error ${error.response.status}:`, error.response.data);
        } else {
          console.error("Error de red o de servidor:", error.message);
        }
        return false; // Retornamos false en lugar de lanzar una excepción
    }
  }
  async updateBannerSingle(bannerId: number, data: FormData): Promise<boolean> {
    try {
      // Realiza la petición PUT utilizando api
      const response = await api.put<ApiResponse<any>>(`${baseURLBanner}/${bannerId}/single`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        });

      // Verifica si la respuesta contiene datos
      if (response.data?.succeeded) {
        // Devuelve true si la actualización fue exitosa
        return true;
      } else {
        console.warn("La API respondió con un formato inesperado:", response.data);
        return false;
      }
    } catch (error: any) {
        // Si hay error en la respuesta, intentamos obtener detalles
        if (error.response) {
          console.error(`Error ${error.response.status}:`, error.response.data);
        } else {
          console.error("Error de red o de servidor:", error.message);
        }
        return false; // Retornamos false en lugar de lanzar una excepción
    }
  }
  async createBanner(data: BannerAPIEntity): Promise<boolean> {
    try {
      
        // Realiza la petición POST utilizando api
        const response = await api.post<ApiResponse<any>>(baseURLBanner, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        });
        
        // Verifica si la respuesta contiene datos
        if (response.data.succeeded === true && response.data?.data) {

          return true;
        } else {
          // Maneja el caso en el que la respuesta no tiene el formato esperado
          throw new Error("La respuesta no tiene el formato esperado o falta el ID del Banner.");
        }
      } catch (error) {
        // Maneja errores de solicitud
        console.error("Error al agregar el Banner:", error);
        throw new Error("Error al agregar el Banner");
      }
  }
  async getBanners(page = 0, pageSize = 10, search: string = ''): Promise<PaginationResult<BannersAPIEntity>> {
     const SortColumn = "order";
    const SortOrder = "asc";
     
    try {
      const response = await api.get<ApiResponse<any>>(baseURLBanner, {
        params: { page, pageSize, search, SortColumn, SortOrder }
      });

      const data = response.data.data;

      if (data && Array.isArray(data.items)) {
        const banners: BannersAPIEntity[] = data.items.map((item: BannersAPIEntity) => ({
          id: item.id,
          imagePrimary: item.imagePrimary,
          created: item.created,
          type: item.type,
          status: item.status,
          order: item.order
        }));

        return {
          items: banners,
          page: data.page,
          pageSize: data.pageSize,
          totalCount: data.totalCount,
          hasNextPage: data.hasNextPage,
          hasPreviousPage: data.hasPreviousPage,
        };
      } else {
        throw new Error("La respuesta no tiene el formato esperado");
      }
    } catch (error) {
      console.error("Error al obtener los productos:", error);
      throw new Error("Error al obtener los productos");
    }
  }
  async getBannerById(bannerId: number): Promise<BannerAPIEntity | null> {
    try {
        const response = await api.get<ApiResponse<any>>(`${baseURLBanner}/${bannerId}`, {
            headers: {
                'Content-Type': 'application/json',
            }
        });

        const bannerData = response.data.data;
        const { imagePrimary, imageSecondary, type, products, product } = response.data.data;

          // Verificación más completa de la respuesta
        if (!response.data?.data) {
            console.warn("La respuesta no contiene datos");
            return null;
        }

          if (bannerData.succeeded===false) {
            console.warn("Datos del banner incompletos o inválidos");
            return null;
        }

        if (!imagePrimary || !imageSecondary || type === undefined) {
          console.warn('Faltan propiedades requeridas en la respuesta');
          return null;
        }

        const productsdata: ProductsAPIEntity[]= products?.map((item: ProductsAPIEntity) => ({
          productId: item.productId,
          productName: item.productName,
          detailListId: item.detailListId,
          mainImage: item.mainImage,
          salePrice: item.salePrice,
          discountPrice: item.discountPrice,
          categoryName: item.categoryName
        })) || [];

        const productdata: ProductAPIEntity | undefined = product
        ? {
            productId: product.productId,
            productName: product.productName,
            mainImage: product.mainImage,
            salePrice: product.salePrice,
            discountPrice: product.discountPrice,
          }
        : undefined;
        
          return {
              imagePrimary: imagePrimary,
              imageSecondary: imageSecondary,
              type: type,
              products: productsdata,
              product: productdata
          };
          
    } catch (error) {
      console.error("Error al obtener los productos:", error);
      if (axios.isAxiosError(error)) {
          console.error("Detalles del error:", error.response?.status, error.response?.data);
      }
      return null;
    }
  }
  async updateStateBanner(data: BannerStateAPIEntity): Promise<boolean> {
    try {
      // Realiza la petición PUT utilizando api
      
      // const response = await api.post(`http://localhost:7066/api/v1/banner/update-status`, data);
      const response = await api.post<ApiResponse<any>>(`${baseURLBanner}/update-status`, data);

      // Verifica si la respuesta contiene datos
      if (response.data?.succeeded) {
        // Devuelve true si la actualización fue exitosa
        return true;
      } else {
        console.warn("La API respondió con un formato inesperado:", response.data);
        return false;
      }
    } catch (error: any) {
        // Si hay error en la respuesta, intentamos obtener detalles
        if (error.response) {
          console.error(`Error ${error.response.status}:`, error.response.data);
        } else {
          console.error("Error de red o de servidor:", error.message);
        }
        return false; // Retornamos false en lugar de lanzar una excepción
    }
  }
  async updateTableBanner(data: BannerAPIEntity): Promise<boolean> {
    try {
      // Realiza la petición PUT utilizando api
      // const response = await api.put(`http://localhost:7066/api/v1/banner/update-order`, data);
      const response = await api.put<ApiResponse<any>>(`${baseURLBanner}/update-order`, data);

      // Verifica si la respuesta contiene datos
      if (response.data?.succeeded) {
        // Devuelve true si la actualización fue exitosa
        return true;
      } else {
        console.warn("La API respondió con un formato inesperado:", response.data);
        return false;
      }
    } catch (error: any) {
        // Si hay error en la respuesta, intentamos obtener detalles
        if (error.response) {
          console.error(`Error ${error.response.status}:`, error.response.data);
        } else {
          console.error("Error de red o de servidor:", error.message);
        }
        return false; // Retornamos false en lugar de lanzar una excepción
    }
  }
  async removeBannerItemTable(bannerId : number): Promise<boolean> {
    try {
      // Realiza la petición DELETE utilizando api
      const response = await api.delete<ApiResponse<any>>(`${baseURLBanner}/${bannerId}`);

      // Verifica si la respuesta contiene datos
      if (response.data.succeeded === true) {
        // Devuelve true si la eliminación fue exitosa
        return true;
      } else {
        // Maneja el caso en el que la respuesta no tiene el formato esperado
        throw new Error("La respuesta no tiene el formato esperado");
      }
    } catch (error) {
      // Maneja errores de solicitud
      console.error("Error al eliminar la fila:", error);
      throw new Error("Error al eliminar la fila");
    }
  }

  async getProducts(page = 0, pageSize = 10, search: string = ''): Promise<PaginationResult<ProductsAPIEntity>> {
    try {
      
      const response = await api.get<ApiResponse<any>>(baseURLProduct, {
        params: { page, pageSize, search },
        headers: {
          'Content-Type': 'application/json',
        }
      });

      const data = response.data.data;

      if (data && Array.isArray(data.items)) {
        const products: ProductsAPIEntity[] = data.items.map((item: ProductsAPIEntity) => ({
          productId: item.productId,
          productName: item.productName,
          categoryName: item.categoryName,
          salePrice: item.salePrice,
          discountPrice: item.discountPrice,
          mainImage: item.mainImage,
        }));

        return {
          items: products,
          page: data.page,
          pageSize: data.pageSize,
          totalCount: data.totalCount,
          hasNextPage: data.hasNextPage,
          hasPreviousPage: data.hasPreviousPage,
        };
      } else {
        throw new Error("La respuesta no tiene el formato esperado");
      }
    } catch (error) {
      console.error("Error al obtener los productos:", error);
      throw new Error("Error al obtener los productos");
    }
  }

  async getOffers(page: number, pageSize: number, search: string, typeOfferImage: number = 0 ): Promise<PaginationResult<OffersAPIEntity>> {
    try {
      const SortColumn = "order";
      const response = await api.get<ApiResponse<any>>(baseURLOffer, {
        params: { page, pageSize, search, SortColumn, typeOfferImage},
        // headers: {
        //   'Content-Type': 'application/json',
        //   'accept': '*/*'
        // }
      });

      const data = response.data.data;

      if (data && Array.isArray(data.items)) {
        const offers: OffersAPIEntity[] = data.items.map((item: OffersAPIEntity) => ({
          id: item.id,
          title: item.title,
          subTitle: item.subTitle,
          typeOfferImages: item.typeOfferImages,
          status: item.status,
          order: item.order
        }));

        return {
          items: offers,
          page: data.page,
          pageSize: data.pageSize,
          totalCount: data.totalCount,
          hasNextPage: data.hasNextPage,
          hasPreviousPage: data.hasPreviousPage,
        };
      } else {
        throw new Error("La respuesta no tiene el formato esperado");
      }
    } catch (error) {
      console.error("Error al obtener los ofertas:", error);
      throw new Error("Error al obtener los ofertas");
    }
  }
  async createOffer(data: OfferAPIEntity): Promise<boolean> {
    try {
      
        // Realiza la petición POST utilizando api
        // const response = await api.post("http://localhost:7066/api/v1/offer", data);
        const response = await api.post<ApiResponse<any>>(baseURLOffer, data, {
           headers: {
            "Content-Type": "multipart/form-data",
          }
        });
        
        // Verifica si la respuesta contiene datos
        if (response.data.succeeded === true) {

          return true;
        } else {
          // Maneja el caso en el que la respuesta no tiene el formato esperado
          throw new Error("La respuesta no tiene el formato esperado o falta el ID de la Oferta.");
        }
      } catch (error) {
        // Maneja errores de solicitud
        console.error("Error al agregar la Oferta:", error);
        throw new Error("Error al agregar la Oferta");
      }
  }
  async updateStateOffer(data: OfferStateAPIEntity): Promise<boolean> {
    try {
      // Realiza la petición PUT utilizando api
      
      const response = await api.post<ApiResponse<any>>(`${baseURLOffer}/update-status`, data);
      

      // Verifica si la respuesta contiene datos
      if (response.data?.succeeded) {
        // Devuelve true si la actualización fue exitosa
        return true;
      } else {
        console.warn("La API respondió con un formato inesperado:", response.data);
        return false;
      }
    } catch (error: any) {
        // Si hay error en la respuesta, intentamos obtener detalles
        if (error.response) {
          console.error(`Error ${error.response.status}:`, error.response.data);
        } else {
          console.error("Error de red o de servidor:", error.message);
        }
        return false; // Retornamos false en lugar de lanzar una excepción
    }
  }
  async updateTableOffer(data: OffersAPIEntity): Promise<boolean> {
    try {
      // Realiza la petición PUT utilizando api
      const response = await api.put<ApiResponse<any>>(`${baseURLOffer}/update-order`, data);
      //const response = await api.put(`http://localhost:7066/api/v1/offer/update-order`, data);

      // Verifica si la respuesta contiene datos
      if (response.data?.succeeded) {
        // Devuelve true si la actualización fue exitosa
        return true;
      } else {
        console.warn("La API respondió con un formato inesperado:", response.data);
        return false;
      }
    } catch (error: any) {
        // Si hay error en la respuesta, intentamos obtener detalles
        if (error.response) {
          console.error(`Error ${error.response.status}:`, error.response.data);
        } else {
          console.error("Error de red o de servidor:", error.message);
        }
        return false; // Retornamos false en lugar de lanzar una excepción
    }
  }
  async updateSliderOffer(itemId: number, data: FormData): Promise<boolean> {
    try {
      // Realiza la petición PUT utilizando api
      //const response = await api.put(`http://localhost:7066/api/v1/offer/${itemId}/update-slider`, data);
      const response = await api.put<ApiResponse<any>>(`${baseURLOffer}/${itemId}/update-slider`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        });

      // Verifica si la respuesta contiene datos
      if (response.data?.succeeded) {
        // Devuelve true si la actualización fue exitosa
        return true;
      } else {
        console.warn("La API respondió con un formato inesperado:", response.data);
        return false;
      }
    } catch (error: any) {
        // Si hay error en la respuesta, intentamos obtener detalles
        if (error.response) {
          console.error(`Error ${error.response.status}:`, error.response.data);
        } else {
          console.error("Error de red o de servidor:", error.message);
        }
        return false; // Retornamos false en lugar de lanzar una excepción
    }
  }
  async getOfferImagesById(id: number): Promise<OfferAPIEntityUpdateImageAndTiner | null> {
      try {
        const response = await api.get<ApiResponse<any>>(`${baseURLOffer}/${id}/image`, {
            headers: {
                'Content-Type': 'application/json',
            }
        });

        const data = response.data?.data;
        const { title, subTitle, typeOfferImages, rows} = response.data?.data;

          // Verificación más completa de la respuesta
        if (!response.data?.data) {
            console.warn("La respuesta no contiene datos");
            return null;
        }

          if (data.succeeded===false) {
            console.warn("Datos del banner incompletos o inválidos");
            return null;
        }

        if (typeOfferImages === undefined) {
          console.warn('Faltan propiedades requeridas en la respuesta');
          return null;
        }

         const offerRowsItemData: OfferRows[] = data.rows?.map((row: OfferRows) => ({
            imageOfferRowId: row.imageOfferRowId,
            offerItems: row.offerItems?.map((item: OfferItemsImageAndTimer) => ({
              id: item.id,
              imageOfferRowId: item.imageOfferRowId,
              imageId: item.imageId,
              urlSingle: item.urlSingle,
              imageUrl: item.imageUrl,
              order: item.order,
              colSize: item.colSize,
              imageSizeType: item.imageSizeType,
              typeOffer: item.typeOffer,
              isMobileVersion: item.isMobileVersion,
              parentImageId: item.parentImageId,
            })) || []
          })) || [];

          return {
              Title: title,
              SubTitle: subTitle,
              TypeOfferImages: typeOfferImages,
              rows: offerRowsItemData,
          };
          
    } catch (error) {
      console.error("Error al obtener los las ofertas tipo imágenes:", error);
      if (axios.isAxiosError(error)) {
          console.error("Detalles del error:", error.response?.status, error.response?.data);
      }
      return null;
    }
  }
  async getOfferSliderById(id: number): Promise<OfferAPIEntityUpdateSlider | null> {
    try {
        const response = await api.get<ApiResponse<any>>(`${baseURLOffer}/${id}/slider`, {
            headers: {
                'Content-Type': 'application/json',
            }
        });

        const bannerData = response.data.data;
        const { title, subTitle, typeOfferImages, offerItems } = response.data.data;

          // Verificación más completa de la respuesta
        if (!response.data?.data) {
            console.warn("La respuesta no contiene datos");
            return null;
        }

          if (bannerData.succeeded===false) {
            console.warn("Datos del banner incompletos o inválidos");
            return null;
        }

        if (typeOfferImages === undefined) {
          console.warn('Faltan propiedades requeridas en la respuesta');
          return null;
        }

        const offerItemsData: OfferItemsSlider[]= offerItems?.map((item: OfferItemsSlider) => ({
          productId: item.productId,
          detailListId: item.detailListId,
          productName: item.productName,
          mainImage:item.mainImage,
          salePrice: item.salePrice,
          discountPrice: item.discountPrice,
          categoryName: item.categoryName
        })) || [];

          return {
              Title: title,
              SubTitle: subTitle,
              TypeOfferImages: typeOfferImages,
              OfferItems: offerItemsData,
          };
          
    } catch (error) {
      console.error("Error al obtener los las ofertas tipo imágenes:", error);
      if (axios.isAxiosError(error)) {
          console.error("Detalles del error:", error.response?.status, error.response?.data);
      }
      return null;
    }
  }
  async getOfferTimerById(id: number): Promise<OfferAPIEntityUpdateImageAndTiner | null> {
     try {
        
        const response = await api.get<ApiResponse<any>>(`${baseURLOffer}/${id}/timer`, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
        const bannerData = response.data?.data;
        const { title, subTitle, typeOfferImages, offerItems } = response.data.data;

          // Verificación más completa de la respuesta
        if (!response.data?.data) {
            console.warn("La respuesta no contiene datos");
            return null;
        }

          if (bannerData.succeeded===false) {
            console.warn("Datos del banner incompletos o inválidos");
            return null;
        }

        if (typeOfferImages === undefined) {
          console.warn('Faltan propiedades requeridas en la respuesta');
          return null;
        }

        const offerRowsItemData: OfferRows[] = bannerData.rows?.map((row: OfferRows) => ({
            imageOfferRowId: row.imageOfferRowId,
            offerItems: row.offerItems?.map((item: OfferItemsImageAndTimer) => ({
              id: item.id,
              imageOfferRowId: item.imageOfferRowId,
              imageId: item.imageId,
              urlSingle: item.urlSingle,
              imageUrl: item.imageUrl,
              order: item.order,
              colSize: item.colSize,
              imageSizeType: item.imageSizeType,
              typeOffer: item.typeOffer,
              isMobileVersion: item.isMobileVersion,
              parentImageId: item.parentImageId,
              startDate: item.startDate,
              endDate: item.endDate,
              darkMode: item.darkMode
            })) || []
          })) || [];

        // const offerItemsData: OfferItemsImageAndTimer[]= offerItems?.map((item: OfferItemsImageAndTimer) => ({
        //   id: item.id,
        //   imageId: item.imageId,
        //   urlSingle: item.urlSingle,
        //   imageUrl: item.imageUrl,
        //   order: item.order,
        //   colSize: item.colSize,
        //   imageSizeType: item.imageSizeType,
        //   typeOffer: item.typeOffer,
        //   startDate: item.startDate,
        //   endDate: item.endDate,
        //   darkMode: item.darkMode
        // })) || [];

          return {
              Title: title,
              SubTitle: subTitle,
              TypeOfferImages: typeOfferImages,
              rows: offerRowsItemData,
          };
          
    } catch (error) {
      console.error("Error al obtener los las ofertas tipo imágenes:", error);
      if (axios.isAxiosError(error)) {
          console.error("Detalles del error:", error.response?.status, error.response?.data);
      }
      return null;
    }
  }
  async removeOfferRow(offerId : number, rowId : string): Promise<boolean> {
    try {
      // Realiza la petición DELETE utilizando api
      const response = await api.delete<ApiResponse<any>>(`${baseURLOffer}/${offerId}/rows/${rowId}`);

      // Verifica si la respuesta contiene datos
      if (response.data.succeeded === true) {
        // Devuelve true si la eliminación fue exitosa
        return true;
      } else {
        // Maneja el caso en el que la respuesta no tiene el formato esperado
        throw new Error("La respuesta no tiene el formato esperado");
      }
    } catch (error) {
      // Maneja errores de solicitud
      console.error("Error al eliminar la fila:", error);
      throw new Error("Error al eliminar la fila");
    }
  }
  async removeOfferItem(rowId: string, itemId: number): Promise<boolean> {
    try {
      // Realiza la petición DELETE utilizando api
      const response = await api.delete<ApiResponse<any>>(`${baseURLOffer}/rows/${rowId}/items/${itemId}`);

      // Verifica si la respuesta contiene datos
      if (response.data.succeeded === true) {
        // Devuelve true si la eliminación fue exitosa
        return true;
      } else {
        // Maneja el caso en el que la respuesta no tiene el formato esperado
        throw new Error("La respuesta no tiene el formato esperado");
      }
    } catch (error) {
      // Maneja errores de solicitud
      console.error("Error al eliminar la item:", error);
      throw new Error("Error al eliminar la item");
    }
  }
  async updateItemOffer(itemId: number, Image: FormData): Promise<boolean> {
      console.log('item ID API:', itemId);
      console.log('fromData API:', Image.get("Image"));
    try {
      // Realiza la petición PUT utilizando api
      const response = await api.put<ApiResponse<any>>(`${baseURLOffer}/items/${itemId}/update-image`, Image, {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        });

      // Verifica si la respuesta contiene datos
      if (response.data.succeeded === true) {
        // Devuelve true si la actualización fue exitosa
        return true;
      } else {
         // Maneja el caso en el que la respuesta no tiene el formato esperado
        throw new Error("La respuesta no tiene el formato esperado");
      }
      
    } catch (error: any) {
        console.error("Error al actualizar imagen de item:", error);
        throw new Error("Error al actualizar imagen de item");
    }
  }
  async updateOfferImages(offerId : number, data: UpdateOffer): Promise<boolean> {
     try {
      // Realiza la petición PUT utilizando api
      const response = await api.put<ApiResponse<any>>(`${baseURLOffer}/${offerId}`, data, {
         headers: {
            "Content-Type": "multipart/form-data",
        }
      });

      // Verifica si la respuesta contiene datos
      if (response.data.succeeded === true) {
        // Devuelve true si la actualización fue exitosa
        return true;
      } else {
         // Maneja el caso en el que la respuesta no tiene el formato esperado
        throw new Error("La respuesta no tiene el formato esperado");
      }
      
    } catch (error: any) {
        console.error("Error al actualizar imagen de item:", error);
        throw new Error("Error al actualizar imagen de item");
    }
  }
  async updateOfferList(itemId: number, data: any): Promise<boolean> {

    try {
      // Realiza la petición PUT utilizando api
      const response = await api.put<ApiResponse<any>>(`${baseURLOffer}/rows/items/${itemId}/item-details`, data);

      // Verifica si la respuesta contiene datos
      if (response.data?.succeeded) {
        // Devuelve true si la actualización fue exitosa
        return true;
      } else {
        console.warn("La API respondió con un formato inesperado:", response.data);
        return false;
      }
    } catch (error: any) {
        // Si hay error en la respuesta, intentamos obtener detalles
        if (error.response) {
          console.error(`Error ${error.response.status}:`, error.response.data);
        } else {
          console.error("Error de red o de servidor:", error.message);
        }
        return false; // Retornamos false en lugar de lanzar una excepción
    }
  }
  async updateOfferSingle(itemId: number, data: any): Promise<boolean> {
    try {
      // Realiza la petición PUT utilizando api
      const response = await api.put<ApiResponse<any>>(`${baseURLOffer}/rows/items/${itemId}/single`, data);

      // Verifica si la respuesta contiene datos
      if (response.data?.succeeded) {
        // Devuelve true si la actualización fue exitosa
        return true;
      } else {
        console.warn("La API respondió con un formato inesperado:", response.data);
        return false;
      }
    } catch (error: any) {
        // Si hay error en la respuesta, intentamos obtener detalles
        if (error.response) {
          console.error(`Error ${error.response.status}:`, error.response.data);
        } else {
          console.error("Error de red o de servidor:", error.message);
        }
        return false; // Retornamos false en lugar de lanzar una excepción
    }
  }
  async getOfferItemSliderById(itemId: number): Promise<OfferItemSliderAPIEntity | null> {
    try {
        const response = await api.get<ApiResponse<any>>(`${baseURLOffer}/rows/items/${itemId}`, {
            headers: {
                'Content-Type': 'application/json',
            }
        });

        const data = response.data.data;
        const { offerItemId, url, typeOffer, products, product } = response.data.data;

          // Verificación más completa de la respuesta
        if (!response.data?.data) {
            console.warn("La respuesta no contiene datos");
            return null;
        }

          if (data.succeeded===false) {
            console.warn("Datos del banner incompletos o inválidos");
            return null;
        }

        // if (!imagePrimary || !imageSecondary || type === undefined) {
        //   console.warn('Faltan propiedades requeridas en la respuesta');
        //   return null;
        // }

        const productsdata: ProductsAPIEntity[]= products?.map((item: ProductsAPIEntity) => ({
          productId: item.productId,
          productName: item.productName,
          detailListId: item.detailListId,
          mainImage: item.mainImage,
          salePrice: item.salePrice,
          discountPrice: item.discountPrice,
          categoryName: item.categoryName
        })) || [];

        const productdata: ProductAPIEntity | undefined = product
        ? {
            productId: product.productId,
            productName: product.productName,
            mainImage: product.mainImage,
            salePrice: product.salePrice,
            discountPrice: product.discountPrice,
          }
        : undefined;
        
          return {
              offerItemId: offerItemId,
              url: url,
              typeOffer: typeOffer,
              products: productsdata,
              product: productdata
          };
          
    } catch (error) {
      console.error("Error al obtener los productos:", error);
      if (axios.isAxiosError(error)) {
          console.error("Detalles del error:", error.response?.status, error.response?.data);
      }
      return null;
    }
  }
  async updateDarkMode(itemId: number, data: any): Promise<boolean> {
    try {
      // Realiza la petición PUT utilizando api
      const response = await api.put<ApiResponse<any>>(`${baseURLOffer}/items/${itemId}/update-theme`, data);

      // Verifica si la respuesta contiene datos
      if (response.data?.succeeded) {
        // Devuelve true si la actualización fue exitosa
        return true;
      } else {
        console.warn("La API respondió con un formato inesperado:", response.data);
        return false;
      }
    } catch (error: any) {
        // Si hay error en la respuesta, intentamos obtener detalles
        if (error.response) {
          console.error(`Error ${error.response.status}:`, error.response.data);
        } else {
          console.error("Error de red o de servidor:", error.message);
        }
        return false; // Retornamos false en lugar de lanzar una excepción
    }
  }
  async updateTimer(itemId: number, data: any): Promise<boolean> {

    try {
     // Realiza la petición PUT utilizando api
    const response = await api.put<ApiResponse<any>>(`${baseURLOffer}/items/${itemId}/update-timer`, data);

      // Verifica si la respuesta contiene datos
      if (response.data?.succeeded) {
        // Devuelve true si la actualización fue exitosa
        return true;
      } else {
        console.warn("La API respondió con un formato inesperado:", response.data);
        return false;
      }
    } catch (error: any) {
        // Si hay error en la respuesta, intentamos obtener detalles
        if (error.response) {
          console.error(`Error ${error.response.status}:`, error.response.data);
        } else {
          console.error("Error de red o de servidor:", error.message);
        }
        return false; // Retornamos false en lugar de lanzar una excepción
    }
  }
  async removeOfferItemTable(offerId: number): Promise<boolean> {
    try {
      // Realiza la petición DELETE utilizando api
      const response = await api.delete<ApiResponse<any>>(`${baseURLOffer}/${offerId}`);

      // Verifica si la respuesta contiene datos
      if (response.data.succeeded === true) {
        // Devuelve true si la eliminación fue exitosa
        return true;
      } else {
        // Maneja el caso en el que la respuesta no tiene el formato esperado
        throw new Error("La respuesta no tiene el formato esperado");
      }
    } catch (error) {
      // Maneja errores de solicitud
      console.error("Error al eliminar la item:", error);
      throw new Error("Error al eliminar la item");
    }
  }


}